import { Component, ElementRef, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavParams } from 'ionic-angular';
import { EventProvider } from '../../providers/event/event';

declare let paypal: any;

@Component({
    selector: 'page-instant-paypal',
    templateUrl: 'instant-paypal.html',
})
export class InstantPaypal {
    @ViewChild('paypal') paypalElement: ElementRef;

    paymentSuccessful: boolean = false;
    paidFor: boolean = false;
    didRenderPaypal: boolean = false;

    amount: string;
    currency: string;
    id: string;
    token: string;

    constructor(
        private navParams: NavParams,
        private eventService: EventProvider,
        private translate: TranslateService
    ) {
        this.amount = this.navParams.get("amount");
        this.currency = this.navParams.get("currency");
        this.id = this.navParams.get("id");
        this.token = this.navParams.get("token");

        this.setupPayPal();
    }

    setupPayPal() {
        let that = this;
        if (!this.didRenderPaypal) {
            let locale = this.translate.getDefaultLang().toUpperCase().includes("DE") ? "de_DE" : "en_US";

            this.loadPaypalScript().then(() => {
                // paypal.Button.render(this.paypalConfig, '#paypal-btn');

                let configs = {
                    // Configure environment
                    env: 'production',
                    client: {
                        sandbox: 'EIRqdIcSWCi68lcQJZw2pGqdSvHkzzop1OCgaFCa4Ur5wf1-Mxf4nSo5jJ4SqKkAm51tph_oztBxN-HY',
                        production: 'AVhHIfBCVbqZWzW-PoFAZXoeJl5u8yT80Y8d1hl2tK8oIpW2tZ-rO7hFn2hC0l0-aivACU0NWMB1KG9m'
                    },
                    // Customize button (optional)
                    locale: locale,
                    style: {
                        size: 'small',
                        color: 'gold',
                        shape: 'pill',
                    },

                    // Enable Pay Now checkout flow (optional)
                    commit: true,

                    // Set up a payment
                    payment: function (data, actions) {
                        return actions.payment.create({
                            transactions: [{
                                amount: {
                                    total: that.amount,
                                    currency: that.currency
                                }
                            }]
                        });
                    },
                    // Execute the payment
                    onAuthorize: function (data, actions) {
                        return actions.payment.execute().then(function () {
                            // Show a confirmation message to the buyer
                            that.onPaymentSuccessful();
                        });
                    }
                };

                paypal
                    .Button.render(configs, this.paypalElement.nativeElement);
            });
        }
    }

    onPaymentSuccessful() {
        this.eventService.saveRegisteredRoute(this.id, this.token).then(() => {

        });

        this.paymentSuccessful = true;
    }

    loadPaypalScript(): Promise<any> {
        this.didRenderPaypal = true;
        return new Promise((resolve, reject) => {
            const scriptElement = document.createElement('script');
            scriptElement.src = 'https://www.paypalobjects.com/api/checkout.js';
            scriptElement.onload = resolve;
            document.body.appendChild(scriptElement);
        });
    }


}



// WEBPACK FOOTER //
// /src/pages/instantpaypal/instant-paypal.ts